import React from 'react';

import Spinner from '@components/Spinner';
import { useCurrentUser, useGroupSubscriptionsRecipients, useTeam } from '@hooks';
import { corporate_landing_path } from '@routes';
import { GROUP_SUBSCRIPTION_TEAM } from '@src/constants';

import SubscriptionOverview from '../GroupSubscription/SubscriptionOverview';
import SettingsHeading from '../SettingsHeading';
import AddTeamMembers from './AddTeamMembers';
import EmailDomainForm from './EmailDomainForm';
import NameForm from './NameForm';
import SignupLink from './SignupLink';
import styles from './styles.module.scss';

export default function Team() {
  const { teamSetting, isTeamLoading } = useTeam();
  const { data: recipients } = useGroupSubscriptionsRecipients(GROUP_SUBSCRIPTION_TEAM);
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const canAccessTeamSubscription = currentUser?.settings_access_obj?.team_sub_access;
  const hasPersistedTeam = !!teamSetting?.team?.id;

  return (
    <>
      {isLoadingCurrentUser || isTeamLoading ? (
        <Spinner />
      ) : (
        <>
          {canAccessTeamSubscription ? (
            <div className={styles.teamSettings}>
              <div className={styles.teamSettingsSection}>
                <NameForm teamSetting={teamSetting} />
                {hasPersistedTeam && (
                  <div data-test="team-access-settings">
                    <EmailDomainForm team={teamSetting?.team} />
                    <SignupLink team={teamSetting?.team} />
                    <AddTeamMembers />
                  </div>
                )}
              </div>

              {hasPersistedTeam && (
                <div data-test="team-additional-settings">
                  <div className={styles.teamSettingsSection}>
                    <SettingsHeading title="Subscriptions">
                      You are currently supporting the following subscriptions for others to The
                      Information
                    </SettingsHeading>
                    {!!recipients && (
                      <SubscriptionOverview
                        recipients={recipients}
                        groupSubscriptionType={GROUP_SUBSCRIPTION_TEAM}
                      />
                    )}
                  </div>
                  <div className={styles.description}>
                    <SettingsHeading title="Bulk Pricing">
                      If you are adding more than 10 people, please reach out to us{' '}
                      <a
                        href={corporate_landing_path}
                        className="!text-primary-red hover:!text-red-400"
                        target="_blank"
                        rel="noreferrer"
                      >
                        here
                      </a>{' '}
                      for bulk pricing.
                    </SettingsHeading>
                  </div>
                  <div className={styles.teamSettingsSection}>
                    <SettingsHeading title="Enterprise Functionality">
                      Need more enterprise functionality like SSO, advanced billing options, higher
                      seat counts, etc., reach out to{' '}
                      <a
                        href="mailto:enterprise@theinformation.com"
                        className="!text-primary-red hover:!text-red-400"
                      >
                        enterprise@theinformation.com
                      </a>
                      .
                    </SettingsHeading>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div id="unaccessible-team-text" className={styles.teamSettings}>
              <div className={styles.teamSettingsSection}>
                <SettingsHeading title="The Information For Your Team">
                  Give your team the information and empower them with the information and
                  connections they need to win in tech — if you setup a team account, you can add
                  people to your &apos;group&apos;, create a custom signup link for your team, or
                  allow anyone with a valid email at your team&apos;s domain to access The
                  Information. You do not currently have access to this program, but if you would
                  like to get access email{' '}
                  <a
                    className="!text-secondary-blue hover:opacity-80"
                    href="mailto:support@theinformation.com"
                  >
                    support@theinformation.com
                  </a>
                </SettingsHeading>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
